import actionTypes from '../constants/action-types';

const interruptions = (state = [], action) => {
  if (action.type !== actionTypes.REGISTER_INTERRUPTION) {
    return state;
  }

  return [...state, action.payload.interruption];
};

export default interruptions;
